import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import config from '@plone/volto/registry';
import { BlockWrapper } from '@kitconcept/volto-bm3-compat';

const LegacyWrapper = (props) => {
  const imagePosition = props.data?.imagePosition === 'left' ? 'left' : 'right';
  const backgroundColor =
    props.data?.backgroundColor === 'red' ? 'red' : 'blue';

  return (
    <div
      className={`banner container dgbbw-banner image-${imagePosition} background-${backgroundColor}`}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

const View = (props) => {
  const { data } = props;
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <BlockWrapper {...props} ExtraWrapper={LegacyWrapper}>
      {data.url && (
        <>
          <Image
            src={`${flattenToAppURL(data.url)}/@@images/image`}
            alt={data.alt || ''}
            className="image"
            loading="lazy"
          />
          <div className="banner-inner-container">
            <div className="text">
              {data.text && <p className="banner-title">{data.text}</p>}
              {data.additionalText && (
                <p className="banner-additional-text">{data.additionalText}</p>
              )}
            </div>
          </div>
        </>
      )}
    </BlockWrapper>
  );
};

export default View;
